export default {"src":"/_next/static/media/arrow-up-red.43e6ab72.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};